/* eslint-disable react/prop-types */
import { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import DialogTitle from '@mui/material/DialogTitle'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogActions from '@mui/material/DialogActions'
import Button from '@mui/material/Button'
import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Checkbox from '@mui/material/Checkbox'
import { ADDITIONAL_RESOURCE_OPTIONS } from '../discountCouponConstants'

function RemoveAutomaticTurboDialog({ open, onClose, onConfirm, isPending }) {
  const [selectedResourceTypes, setSelectedResourceTypes] = useState([])

  function toggleResourceType(value) {
    setSelectedResourceTypes((current) =>
      current.includes(value) ? current.filter((entry) => entry !== value) : [...current, value],
    )
  }

  function handleConfirm() {
    onConfirm(selectedResourceTypes.length > 0 ? selectedResourceTypes : undefined)
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Remover cupons automáticos de turbo</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ mb: 2 }}>
          Selecione quais turbos devem ser removidos. Nenhum selecionado remove todos.
        </DialogContentText>
        <FormGroup>
          {ADDITIONAL_RESOURCE_OPTIONS.map((option) => (
            <FormControlLabel
              key={option.value}
              control={
                <Checkbox
                  checked={selectedResourceTypes.includes(option.value)}
                  onChange={() => toggleResourceType(option.value)}
                />
              }
              label={option.label}
            />
          ))}
        </FormGroup>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" color="error" onClick={handleConfirm} disabled={isPending}>
          Remover
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default RemoveAutomaticTurboDialog
